import "bootstrap/dist/js/bootstrap.bundle.js";
import "react-datepicker/dist/react-datepicker.css";
import "./i18n/config";
import "./main.scss";

import * as msal from "@azure/msal-browser";
import { Component } from "react";
import * as ReactDOM from "react-dom";
import { NotificationContainer } from "react-notifications";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import Loader from "components/loader/loader";
import { fetchInitialConfiguration } from "store/fetchInitialConfiguration";

import ErrorView from "./components/errorView/errorView";
import ReactNotification from "./components/reactNotification/reactNotification";
import ErrorBoundary from "./error/components/errorBoundary/errorBoundary";
import MsalFactory from "./factories/msalFactory";
import App from "./pages/app";
import FeatureFlagProvider from "./providers/featureFlagProvider";
import TelemetryProvider from "./providers/telemetryProvider";
import AccessService from "./services/accessService";
import StoreFactory from "./store/store";
import AppEventHub from "./utils/appEventHub";

AppEventHub.initialize();
MsalFactory.initialize();
ReactNotification.manageNotifications();

const store = StoreFactory.Create();
store.subscribe(handleStoreChangeSubscription);

function handleStoreChangeSubscription(): void {
  FeatureFlagProvider.manageFlagChanges(store.getState().generalState.featureFlags);
}

interface MainState {
  isAuthenticated: boolean;
  user: msal.AccountInfo | null;
  isLoading: boolean;
}

class Main extends Component<any, MainState> {
  private readonly accessService: AccessService;

  public constructor(props) {
    super(props);
    this.accessService = new AccessService();
    this.state = {
      isAuthenticated: false,
      user: null,
      isLoading: true,
    };
  }

  public async componentDidMount(): Promise<void> {
    try {
      const { user, isAuthenticated } = await this.accessService.ensureAccessAsync();
      this.setState({ isAuthenticated, user, isLoading: false });
      if (isAuthenticated) {
        store.dispatch(fetchInitialConfiguration());
      }
    } catch {
      this.setState({ isAuthenticated: false, isLoading: false });
    }
  }

  public render(): React.ReactNode {
    if (this.state.isLoading) {
      return <Loader isLoading={true}></Loader>;
    }
    return (
      <Router>
        <TelemetryProvider>
          <ErrorBoundary>
            <NotificationContainer />
            <Provider store={store}>
              {this.state.isAuthenticated ? <App location={window.location} /> : <ErrorView user={this.state.user} />}
            </Provider>
          </ErrorBoundary>
        </TelemetryProvider>
      </Router>
    );
  }
}

ReactDOM.render(<Main />, document.getElementById("root") as HTMLElement);
